<div class="navbar-header">
    <a class="" rel="home" href="#" title="">
        <img class="responsive" style="width:100%;height: auto;"
             src="assets/images/header-1.jpg">
    </a>
</div>
<section id="header" class="rounded" style="margin-top:1%;background-color:white;text-align: center;text-emphasis-color: inherit"><strong>Assam Engineering Institute</strong>
    <div class="container">
        <div class="row" >
            <div class="col-md-12 col-xs-12 col-centered" style="align-items: center;
            text-decoration: underline;">
            <strong>Online Fee payment</strong></div>
        </div>
    </div>
</section>
<div class="card" style="margin-top: 1%">
<h4 class="card-header">Student Fee Details</h4>
<div class="card-body" *ngIf="((!isRecordNotFound))" >


    <form [formGroup]="form" >

        <div class="studentDetailsDiv">

            <div class="form-group" style="width:90%">
                <mat-form-field (focus)="hideError('month')" class="mt5 wrapper"style="width:100%" >
                <mat-label>Select Month</mat-label>
                <mat-select matInput formControlName="month" panelClass="testClass" autocomplete="off" required (selectionChange)="onMonthChange($event)" multiple>
                  <mat-option value="January">January</mat-option>
                  <mat-option value="February">February</mat-option>
                  <mat-option value="March">March</mat-option>
                  <mat-option value="April">April</mat-option>
                  <mat-option value="May">May</mat-option>
                  <mat-option value="June">June</mat-option>
                  <mat-option value="July">July</mat-option>
                  <mat-option value="August">August</mat-option>
                  <mat-option value="September">September</mat-option>
                  <mat-option value="October">October</mat-option>
                  <mat-option value="November">November</mat-option>
                  <mat-option value="December">December</mat-option>

                </mat-select>
                  <mat-error *ngIf="form.controls['month'].hasError('required')">Month is required.</mat-error>
                </mat-form-field>
              </div>

              <div class="form-group" >
                <mat-form-field style="width:100%">
                  <mat-label>Month Dues</mat-label>
                  <input type="number" matInput maxlength="50" placeholder="Month Dues" formControlName="monthDues" [readonly]="true" required/>
                  <mat-error *ngIf="form.controls['monthDues'].hasError('required')">Month Dues are required.</mat-error>
                </mat-form-field>
                {{monthDues}}           
              </div>
    


            <div class="form-group form-obj" style="width:90%">
              <strong> <label for="studentName"> Student Name :</label></strong> {{studentData.studentName}}
            </div>

            <div class="form-group form-obj" style="width:90%">
                <strong> <label for="hostelNo">Hostel No :</label></strong> {{studentData.hostelNo}}
            </div>

          <div class="form-group form-obj" style="width:90%">
            <strong> <label for="messDues"> Mess Dues:</label></strong> {{studentData.messDues}}
          </div>

          <div class="form-group form-obj" style="width:90%">
              <strong> <label for="parentName"> Parents / Guardian Name :</label></strong> {{studentData.parentName}}
          </div>

          
          <div class="form-group form-obj" style="width:90%">
            <strong> <label for="phooneNo"> Phone No :</label></strong> {{studentData.phoneNo}}
        </div>

        <div class="form-group" style="width:90%">
            <mat-form-field (focus)="hideError('disability')" class="mt5 wrapper"style="width:100%" >
            <mat-label>Select Disability</mat-label>
            <mat-select matInput formControlName="disability" panelClass="testClass" autocomplete="off" required >
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
            </mat-select>
              <mat-error *ngIf="form.controls['disability'].hasError('required')">Disability is required.</mat-error>
            </mat-form-field>
          </div>

          <div class="form-group form-obj" style="width:90%">
            <strong> <label for="dueDate"> Due Date:</label></strong> {{dueDate}}
          </div>

           
        <div class="form-group form-obj" *ngIf="this.lateFee >0" style="width:90%">
            <strong> <label for="lateFee"> late Fee :</label></strong> {{this.lateFee}}
        </div>

        <div class="form-group form-obj" style="width:90%">
            <mat-form-field style="width:100%">
              <mat-label><h4><b>Total Amount</b></h4></mat-label>
              <h4><b><input type="number"  matInput placeholder="Total Amount" formControlName="totalAmount" value ={{getTotal()}} autocomplete="of" [readonly]="true" required /></b></h4>
            </mat-form-field>
      </div>
        
         

        </div>

        <div class="col-md-12" style="display: inline-block;">


            <div class="form-group">
                <button [disabled]="loading" style="margin-right:30px;" class="btn btn-primary" (click)="onSubmit()">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Pay Now
                </button>
                <button (click)="redirectHome()" class="btn btn-primary" >
                  BACK TO HOME
                </button>
            </div>

        </div>


    </form>
    <div>
      <form   target="_top" #txnForm [formGroup]="tranxnForm" method="POST" action={{isgPay_url}}  >
        <input type="hidden" [value]="EncDataField"  name="EncData" formControlName="EncData">
        <input type="hidden" [value]="MerchantIdField" name="MerchantId" formControlName="MerchantId">
        <input type="hidden" [value]="BankIdField" name="BankId" formControlName="BankId">
        <input type="hidden" [value]="TerminalIdField" name="TerminalId" formControlName="TerminalId">
        <input type="hidden" [value]="VersionField" name="Version" formControlName="Version">
        <input type="hidden" [value]="TransactionId" name="OrderId" formControlName="TransactionId">


        </form>
      </div>
</div>
<div class="card-body" *ngIf="isRecordNotFound" >
  {{res.message}}
  <div class="errBackButtonDiv" style="width: 129px !important; margin-top: 30px;
               margin-bottom: 20px;">
                 <button style="font-size: 13px !important;" class="errBackButton" mat-raised-button (click)="redirectHome()" color="primary">BACK TO HOME</button>
  </div>
</div>
</div>
